module.exports = __webpack_public_path__ + "img/4.3e38d995.jpg";